import React from 'react'
import Button from '../buttons/Button'
import successIcon from '../../assets/images/green_tick.svg'
import errorIcon from '../../assets/images/ErrorIcon.svg'

const FeedbackSubmited = ({ success, onClose }) => {

    const handleTryAgain = () => {
        onClose()
        // openFeedbackModal()        
    }

    return (
        <div className='h-[240px] w-[518px] flex flex-col'>
            <div className="h-[128px] pt-[40px] pb-[24px] px-[24px] border-b">
                <div className='h-[64px] w-[438px] flex flex-col gap-[8px] '>
                    <h5 className="h-[32px] flex items-center gap-[8px] ">
                        <span className='text-[28px] font-helveticaText-Medium leading-[32px] font-[500] text-cus_primary'>
                            {success ? "Thank you!" : "Feedback couldn't be shared"}
                        </span>
                        <img src={success ? successIcon : errorIcon} alt="success icon" className='h-[24px] w-[24px]' /> 
                    </h5>
                    <p className='text-cus_secondary leading-[24px] tracking-[-0.02em]'>
                        {success ? "Your feedback has been shared successfully." : "Please try submitting your feedback again."}
                    </p>
                </div>
            </div>

            <div className='h-[112px]'>
                <div className="flex gap-[16px] px-10 pt-6 pb-10 border-t">
                    <Button onClick={onClose} label='Close' className="bg-gray-light hover:bg-gray-hoverLight text-cus_primary " />
                    {!success && <Button onClick={handleTryAgain} label='Try again' className="bg-blue-primary hover:bg-blue-dark text-white  " />}

                </div>
            </div>
        </div>
    )
}

export default FeedbackSubmited